import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-474bf254"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content-li left-content"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "content-li right-content"
};
const _hoisted_4 = {
  class: "micro-title"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "micro-info"
};
const _hoisted_7 = {
  class: "info-detail"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 培训时间： ");

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" - ");

const _hoisted_10 = {
  class: "info-detail"
};
const _hoisted_11 = {
  class: "micro-data"
};
const _hoisted_12 = {
  class: "data-item"
};
const _hoisted_13 = {
  class: "color-unit"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-name"
}, "运行学期", -1));

const _hoisted_15 = {
  class: "data-item"
};
const _hoisted_16 = {
  class: "color-unit"
};

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-name"
}, "课程数量", -1));

const _hoisted_18 = {
  class: "data-item"
};
const _hoisted_19 = {
  class: "color-unit"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-name"
}, "班级人数", -1));

const _hoisted_21 = {
  class: "data-item"
};
const _hoisted_22 = {
  class: "color-unit"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "data-name"
}, "教学方式", -1));

const _hoisted_24 = {
  class: "micro-intro"
};
const _hoisted_25 = ["innerHTML"];

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看详情 >", -1));

const _hoisted_27 = [_hoisted_26];
export default {
  props: {
    specialtyIndex: Number,
    specialtyData: Object
  },

  setup(__props) {
    const props = __props;
    const $utils = inject('$utils');
    const menuId = $utils.getUrlParams('menuId');
    const name = $utils.getUrlParams('name');

    const goDetail = item => {
      window.location.href = `/microSpecialtyDetail.html?menuId=${menuId}&name=${name}&id=${item.specialty_id}&termId=${item.specialty_term_id}`;
    };

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "card-content",
        style: _normalizeStyle({
          flexFlow: __props.specialtyIndex % 2 == 0 ? '' : 'row-reverse'
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "cover-img",
        onClick: _cache[0] || (_cache[0] = $event => goDetail(__props.specialtyData))
      }, [_createElementVNode("img", {
        src: __props.specialtyData.coverImag,
        alt: ""
      }, null, 8, _hoisted_2)])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "text-content",
        style: _normalizeStyle({
          paddingLeft: __props.specialtyIndex % 2 == 0 ? '30px' : '0',
          paddingRight: __props.specialtyIndex % 2 == 0 ? '0' : '30px'
        })
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(__props.specialtyData.specialty_name), 1)]), _createElementVNode("ul", _hoisted_6, [_createElementVNode("li", null, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_unref($utils).formatDate(__props.specialtyData.open_class_time, 'YYYY.MM.DD')), 1), _hoisted_9, _createElementVNode("span", null, _toDisplayString(_unref($utils).formatDate(__props.specialtyData.end_time, 'YYYY.MM.DD')), 1)])]), _createElementVNode("li", null, [_createElementVNode("div", _hoisted_10, "培训地点：" + _toDisplayString(__props.specialtyData.training_place || '—'), 1)])]), _createElementVNode("ul", _hoisted_11, [_createElementVNode("li", _hoisted_12, [_createElementVNode("div", _hoisted_13, "第" + _toDisplayString(__props.specialtyData.term || '0') + "学期", 1), _hoisted_14]), _createElementVNode("li", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(__props.specialtyData.course_count || '—'), 1), _hoisted_17]), _createElementVNode("li", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(__props.specialtyData.recruit_num || '—'), 1), _hoisted_20]), _createElementVNode("li", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(__props.specialtyData.teaching_methods), 1), _hoisted_23])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("a", {
        innerHTML: _unref($utils).getContentText(__props.specialtyData.training_info)
      }, null, 8, _hoisted_25)]), _createElementVNode("div", {
        class: "title-detail-btn",
        onClick: _cache[1] || (_cache[1] = $event => goDetail(__props.specialtyData))
      }, _hoisted_27)], 4)])], 4);
    };
  }

};